// import { useServices } from "../../core/servicesContext";
// import { PaginatedDataResult, usePaginatedStore } from "../../utils/hooks";
// import { useCurrentProfile } from "../currentProfile/hooks";
import { PaginatedDataResult } from "@utils/hooks";
import { Report } from "@domain/report/report";
import { Profile } from "@domain/user/profile";

const fakeReporter: Profile = {
	id: "reporter-1",
	primaryName: "Jane Doe",
	type: "USER",
	description: "",
	followerCount: 0,
	followeeCount: 0,
	customData: {},
	categories: [],
};

const fakeReports: Report[] = [
	{
		id: "1",
		status: "PENDING",
		reporter: fakeReporter,
		date: new Date(),
		motive: "INAPPROPRIATE",
		contentType: "USER",
	},
];

export function useReports(): PaginatedDataResult<Report> {
	return {
		result: fakeReports,
		totalElements: fakeReports.length,
		totalPages: 1,
		loading: false,
		error: null,
		fetch: async () => {},
		fetchMore: async () => {},
		moreLoading: false,
		lastPage: true,
	};
	// const { adminContentService } = useServices();
	// const currentProfile = useCurrentProfile();
	// return usePaginatedStore(adminContentService.reportStorePresentation, [currentProfile]);
}
